import React from "react";
import { FontText } from "./common.jsx";
export const headlines = {
  newspaper: "ქალაქი, რომელიც ახალ ამბებს ქმნის",
  website: "ვქმნით იდეებს, რომლებიც ცხოვრებას ცვლის",
  banner: "მიეცით თქვენს იდეას ფორმა",
  poster: "ასოები გვაერთიანებს",
};
const paragraphs = [
  "თბილისი ყოველდღე ახალ ისტორიას წერს. ძველი უბნების ვიწრო ქუჩებში შემოქმედებითი სივრცეები ჩნდება, სადაც სხვადასხვა თაობის ადამიანები იდეებს ერთმანეთს უზიარებენ. ქალაქის ხასიათი სწორედ ამ შეხვედრებში იბადება.",
  "ამ ნომერში ვსაუბრობთ ადამიანებზე, რომლებიც გარემოს ახალი თვალით უყურებენ. არქიტექტურა, ხელოვნება და ყოველდღიური ურთიერთობები ერთ საერთო ამბად იქცევა — ამბად იმაზე, თუ როგორ ვცხოვრობთ ერთად.",
  "ქართული ასო საუკუნეების მეხსიერებას ინახავს. მისი ფორმა იცვლება, მაგრამ ხმა რჩება: სიტყვები გვაკავშირებს წარსულთან და გვაძლევს საშუალებას, მომავალი ჩვენი ენით წარმოვიდგინოთ.",
];
function Landscape({ variant = "city" }) {
  return (
    <div
      className={"editorial-art art-" + variant}
      role="img"
      aria-label={
        variant === "city"
          ? "Illustrated city skyline"
          : "Abstract design composition"
      }
    >
      <span />
      <i />
      <b />
      <em />
      <small />
    </div>
  );
}
export function Scene({ font, kind, headline, full = false }) {
  const title = headline || headlines[kind];
  const F = ({ children, as = "p", ...props }) => (
    <FontText font={font} text={children} as={as} {...props} />
  );
  if (kind === "newspaper")
    return (
      <div className={"scene newspaper " + (full ? "full-newspaper" : "")}>
        <div className="paper-top">
          <span>დამოუკიდებელი გამოცემა / თბილისი</span>
          <span>სანიმუშო ნომერი · 2026</span>
        </div>
        <F as="div" className="newspaper-mast">
          თბილისის ამბები
        </F>
        <div className="newspaper-date">
          <span>ქალაქი · კულტურა · ადამიანები</span>
          <span>ოთხშაბათი, 30 სექტემბერი</span>
          <span>№ 01 / ფასი 2 ₾</span>
        </div>
        <div className="paper-sections">
          მთავარი ამბავი　 /　 საზოგადოება　 /　 კულტურა　 /　 არქიტექტურა　 /　
          აზრი
        </div>
        <div className="newspaper-body">
          <div className="newspaper-main">
            <p className="scene-kicker">დღის მთავარი ამბავი / ქალაქი</p>
            <F as="h2" data-context-heading>
              {title}
            </F>
            <F className="scene-lead">
              იდეები, რომლებიც გვაკავშირებს. ადამიანები, რომლებიც ყოველდღიურობას
              განსაკუთრებულს ხდიან.
            </F>
            <p className="paper-byline">
              ავტორი: ნინო მაისურაძე　 ·　 7 წუთის საკითხავი
            </p>
            <figure>
              <Landscape />
              <figcaption>
                ქალაქის ძველი და ახალი სახეები — ვიზუალური ილუსტრაცია
              </figcaption>
            </figure>
            <div className="newspaper-columns">
              {paragraphs.map((p, i) => (
                <F key={i}>{p}</F>
              ))}
            </div>
          </div>
          <aside>
            <p className="scene-kicker">ამ ნომერში</p>
            <F as="h3">იდეების ქალაქი</F>
            <F>
              შემოქმედებითი სივრცეები და ადამიანები, რომლებიც ქალაქს ცვლიან.
            </F>
            <hr />
            <Landscape variant="forms" />
            <F as="h3">ასოს ხელოვნება</F>
            <F>
              ქართული ტიპოგრაფიის ახალი თაობა: როცა ტრადიცია თანამედროვე ფორმას
              იძენს.
            </F>
            <hr />
            <p className="scene-kicker">რედაქტორის წერილი</p>
            <F>სივრცე, სადაც სიტყვას მნიშვნელობა აქვს</F>
          </aside>
        </div>
        {full && (
          <>
            <div className="paper-pullquote">
              <F as="blockquote">„კარგი ქალაქი ადამიანების ამბებით იწყება.“</F>
              <span>კვირის საუბარი / კულტურა და საზოგადოება</span>
            </div>
            <div className="paper-stories">
              {[
                "სახლები, რომლებიც გვიყვებიან",
                "ახალი სახელები ქართულ დიზაინში",
                "წერილები ჩვენი მკითხველისგან",
              ].map((h, i) => (
                <article key={h}>
                  <p className="scene-kicker">
                    0{i + 1} / {["არქიტექტურა", "კულტურა", "საზოგადოება"][i]}
                  </p>
                  <F as="h3">{h}</F>
                  <F>{paragraphs[i]}</F>
                  <span className="paper-read">
                    გაგრძელება გვერდზე {i + 2} →
                  </span>
                </article>
              ))}
            </div>
            <div className="paper-weekend">
              <div>
                <span className="scene-kicker">შაბათ-კვირის გზამკვლევი</span>
                <F as="h3">სად შევხვდებით ერთმანეთს?</F>
                <F>
                  გამოფენები, ღია სახელოსნოები და საუბრები ქალაქის ახალ
                  სივრცეებში. შეარჩიეთ თქვენი მარშრუტი და აღმოაჩინეთ ნაცნობი
                  ქუჩები თავიდან.
                </F>
              </div>
              <Landscape variant="forms" />
            </div>
            <footer className="paper-footer">
              <span>თბილისის ამბები / დამოუკიდებელი გამოცემა</span>
              <span>სანიმუშო დიზაინი · Fontlab</span>
              <span>01</span>
            </footer>
          </>
        )}
      </div>
    );
  if (kind === "website")
    return (
      <div className={"scene website " + (full ? "full-website" : "")}>
        <div className="mock-browser">
          <i />
          <i />
          <i />
          <span>space-studio.example</span>
        </div>
        <div className="website-nav">
          <F as="b">სივრცე®</F>
          <span>ნამუშევრები　 სტუდია　 მიდგომა　 კონტაქტი</span>
          <a
            href="#work"
            onClick={(e) => {
              e.preventDefault();
              e.currentTarget
                .closest(".website")
                .querySelector(".web-projects")
                ?.scrollIntoView({ block: "start", behavior: "smooth" });
            }}
          >
            მოგვწერეთ ↗
          </a>
        </div>
        <div className="web-hero-grid">
          <div className="website-hero">
            <p className="scene-kicker">
              თბილისი / დამოუკიდებელი დიზაინის სტუდია
            </p>
            <F as="h2" data-context-heading>
              {title}
            </F>
            <F>
              ვქმნით ბრენდებსა და ციფრულ გამოცდილებებს, რომლებიც ადამიანებს
              ერთმანეთთან აკავშირებს. სტრატეგიიდან პირველ შთაბეჭდილებამდე —
              ყველა დეტალს თავისი ამბავი აქვს.
            </F>
            <a
              className="mock-button"
              href="#work"
              onClick={(e) => {
                e.preventDefault();
                e.currentTarget
                  .closest(".website")
                  .querySelector(".web-projects")
                  ?.scrollIntoView({ block: "start", behavior: "smooth" });
              }}
            >
              ნახეთ ნამუშევრები ↗
            </a>
          </div>
          <div className="web-art">
            <Landscape variant="forms" />
            <F as="strong">{"ფორმა. იდეა."}</F>
            <span>BRAND / DIGITAL / CULTURE</span>
          </div>
        </div>
        <div className="web-partners">
          <span>იდეებიდან რეალურ ცვლილებამდე</span>
          <b>FORMA</b>
          <b>თაღი</b>
          <b>STORY</b>
          <b>მწვანე</b>
        </div>
        {full && (
          <>
            <section className="web-projects" id="work">
              <div className="web-section-title">
                <div>
                  <p className="scene-kicker">01 / შერჩეული ნამუშევრები</p>
                  <F as="h2">იდეები მოქმედებაში.</F>
                </div>
                <span>2024 — 2026</span>
              </div>
              <div className="web-project-grid">
                {[
                  "ქალაქის ახალი ხმა",
                  "ბუნებასთან ახლოს",
                  "კულტურა, რომელიც გვაერთიანებს",
                  "ყოველდღიურობის ახალი რიტმი",
                ].map((h, i) => (
                  <article key={h}>
                    <div className={"project-art project-" + i}>
                      <span>0{i + 1}</span>
                      <F as="strong">
                        {["ამბავი", "მწვანე", "ფორმა", "რიტმი"][i]}
                      </F>
                      <i />
                    </div>
                    <div className="project-caption">
                      <F as="h3">{h}</F>
                      <span>
                        {i % 2 ? "ციფრული გამოცდილება" : "ბრენდის იდენტობა"} ↗
                      </span>
                    </div>
                  </article>
                ))}
              </div>
            </section>
            <section className="web-about">
              <div>
                <p className="scene-kicker">02 / როგორ ვმუშაობთ</p>
                <F as="h2">დიდი ამბავი პატარა კითხვით იწყება.</F>
                <F>
                  ჩვენთვის დიზაინი მხოლოდ გარეგნობა არ არის. ეს არის გზა,
                  რომლითაც ბრენდი საუბრობს, უსმენს და ურთიერთობას ქმნის.
                </F>
              </div>
              <div className="web-services">
                {[
                  "ვუსმენთ და ვიკვლევთ",
                  "ვპოულობთ მთავარ იდეას",
                  "ვაძლევთ იდეას ფორმას",
                  "ვუშვებთ სამყაროში",
                ].map((h, i) => (
                  <div key={h}>
                    <span>0{i + 1}</span>
                    <F as="h3">{h}</F>
                    <b>↗</b>
                  </div>
                ))}
              </div>
            </section>
            <section className="web-contact">
              <p className="scene-kicker">
                შემდეგი ამბავი შეიძლება თქვენი იყოს.
              </p>
              <F as="h2">{"მოდით, შევქმნათ რაღაც მნიშვნელოვანი."}</F>
              <span className="mock-button">დავიწყოთ საუბარი ↗</span>
            </section>
          </>
        )}
        <footer className="website-footer">
          <F as="b">სივრცე®</F>
          <span>თბილისი, საქართველო</span>
          <span>სტრატეგია · იდენტობა · ციფრული დიზაინი</span>
          <span>სანიმუშო ვებსაიტი / Fontlab</span>
        </footer>
      </div>
    );
  if (kind === "banner")
    return (
      <div className="scene banner">
        <div className="banner-top">
          <span>ფორმა / შემოქმედებითი სივრცე</span>
          <span>ახალი სეზონი</span>
        </div>
        <F as="h2" data-context-heading>
          {title}
        </F>
        <div className="banner-bottom">
          <p>
            იპოვეთ თქვენი შთაგონება.
            <br />
            მიეცით იდეას ფორმა.
          </p>
          <span className="mock-button">აღმოაჩინეთ მეტი</span>
        </div>
      </div>
    );
  return (
    <div className="scene poster">
      <div className="poster-top">
        <span>
          ტიპოგრაფია
          <br />
          კულტურა
          <br />
          იდეები
        </span>
        <F as="span" className="poster-number">
          აბ
        </F>
      </div>
      <F as="h2" data-context-heading>
        {title}
      </F>
      <div className="poster-bottom">
        <strong>
          01—03
          <br />
          ოქტომბერი
        </strong>
        <span>
          თბილისი
          <br />
          სანიმუშო აფიშა
        </span>
      </div>
    </div>
  );
}
